import React, { Component, Fragment } from 'react';

class SelectorStatesCountry extends Component {
  render() {
    const { showModalStatesUpdate, stateSelected } = this.props;
    return (
      <div className="alignmentRow">
        <button
          className="resetDefaultStyleBtn selectStateCountry"
          onClick={() => {
            showModalStatesUpdate();
          }}
        >
          <Fragment>
            {stateSelected.nameState || (<span>Selecciona tu estado</span>) }
            <img
              src="https://assetspwa.liverpool.com.mx/static/images/arrow-drop-down.svg"
              alt="icon"
              className="arrow_down_states"
            />
          </Fragment>
        </button>
      </div>
    );
  }
}

export default SelectorStatesCountry;
